import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ModuleIcon, ThreeDIcon } from "../../../assets/Icons";

const Sidebar = ({ sideBar, setSideBar }) => {
  const navigate = useNavigate();
  const currentLocation = useLocation();
  const currentPath = currentLocation.pathname;
  const [activeTab, setActiveTab] = useState('xr');

  useEffect(() => {
    if (currentPath.startsWith('/dashboard/xr')) setActiveTab('xr');
    else if (currentPath.startsWith('/dashboard/environments')) setActiveTab('environments');
    else if (currentPath.startsWith('/dashboard/3d')) setActiveTab('assets');
    else if (currentPath.startsWith('/dashboard/2d/lms')) setActiveTab('lms');
  }, [currentPath]);

  return (
    
      <div className={sideBar ? "sidmenu active" : "sidmenu"}>
        <div className="mainsidelist">
          <ul>

            <li className={`${activeTab === 'xr' ? 'active' : ''}`} onClick={() => { navigate("/dashboard/xr") }} >
              <ModuleIcon/>
              <p className="ms-3">XR Modules</p>
            </li>

            <li className={`${activeTab === 'assets' ? 'active' : ''}`} onClick={() => { navigate("/dashboard/3d") }} >
              <ThreeDIcon/>
              <p className="ms-3">3D Assets</p>
            </li>

          
          </ul>
        </div>
      </div>
    
  );
};

export default Sidebar;
